export const timeStringToSeconds = (timeString: string): number => {
  // Split the input string by colon
  const parts = timeString.split(':').map((part) => parseInt(part, 10));

  // Validate the parts to ensure they are numbers and within valid ranges
  if (parts.some(isNaN) || parts.length < 2 || parts.length > 3) {
    throw new Error('Invalid time format');
  }

  const [hours, minutes, seconds = 0] = parts;

  if (hours < 0 || minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59) {
    throw new Error('Invalid time values');
  }

  // Convert hours and minutes to seconds and add them together
  return hours * 3600 + minutes * 60 + seconds;
};
